import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import styled from 'styled-components';
import es from "date-fns/locale/es";
import Dropdown from './Dropdown';
import { getAllsContactsPagination, updateContactById, getContactByID } from "../../../../endpoints"
import {obtenerFechaYHoraActual} from "../../../../Utils/index"
import { useNavigate, useLocation } from "react-router-dom";
const modifiedEs = {
  ...es,
  localize: {
    ...es.localize,
    month: (monthIndex, options) => {
      const monthName = es.localize.month(monthIndex, options);
      return monthName.charAt(0).toUpperCase() + monthName.slice(1);
    },
  },
};

export default function ModalCalendario(
  { 
    onClose,
    updateContactById,
    contacto,
    stopPropagation,
    setSeActualizoContacto,
    getContacts,
    getContactID,
    setContacts,
    scrollContainerRef,
    statusContactFilter,
    user,
    setRefresh
   }) {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState('');

  const [statusContact, setStatusContact] = useState(contacto.status ||  null);
  const [viaDeContacto, setViaDeContacto] = useState(contacto.viaDeContacto || null);
  const [observaciones, setObservaciones] =useState(null)
  const [fechaHora, setFechaHora] = useState();
  const navigate = useNavigate();

  
  const statusOptions = [
    "No Contactado",
    "Contactado",
    "Sin Respuesta",
    // "En Seguimiento"
  ]
  const viaDeContactoOptions = [
    "Whatsapp",
    "Telefono",
    "Instagram",
    "Otro"
  ]


  const handleGuardar = () => {
    // Obtener la fecha seleccionada
    const fechaSeleccionada = selectedDate ? format(selectedDate, 'yyyy-MM-dd') : '';
    const horaSeleccionada = selectedTime ? selectedTime : '';
    const fechaHora = `${fechaSeleccionada}T${horaSeleccionada}:00.000Z`;
    if (

      !viaDeContacto ||
      !statusContact ||
      !observaciones
    ) {
      console.log("ERROR")
    } else {
      updateContactById({
        id: contacto.id,
        fechaDeContacto: obtenerFechaYHoraActual,
        viaDeContacto: viaDeContacto,
        status: statusContact,
        observaciones:observaciones,
        idAsesorAsignado: user.id
      }).then((response) => {
        if(response.status === 200){
          if(statusContact === "Contactado"){
            navigate('/seguimientos/' + `${contacto.id}`)
          }
          console.log(response)
          console.log("SE ACTUALIZO")
          setSeActualizoContacto(true)

          getAllsContactsPagination({
            page: 1,
            perPage: 30,
            userId:user.id,
            status:statusContactFilter,
            userType:user.type
          }).then((res) => {
           if(res.status === 200){
            console.log(res.data, "ASDASD")
            setContacts(res.data.contacts)
            if (scrollContainerRef.current) {
              scrollContainerRef.current.scrollTop = 0;
            }
           }else {
            console.log("error")
           }
          })
          getContactID(contacto.id)
          onClose();
        }else {
          console.log(response)
          console.log("OCURRIO UN ERROR")
        }
      })
    }
    console.log("Fecha y hora seleccionadas:", fechaHora);

  };
  const handleCancelar = () => {
    onClose();
  };


  const handleTextAreareaOnChange = (e) => {
    
   
    setObservaciones(e.target.value);
  }


  return (
    <ModalWrapper onClick={handleCancelar}>
      <ModalContent onClick={stopPropagation}>
        <span>Seleccione fecha y hora del contacto *</span>
        <DayPicker
          mode="single"
          selected={selectedDate}
          onSelect={setSelectedDate}
          locale={modifiedEs}
        />

        {/* <TimePicker
          value={selectedTime}
          onChange={e => setSelectedTime(e.target.value)}
        /> */}
        <span style={{
          fontFamily: "'Montserrat', sans-serif"
        }}>Via de Contacto *</span>
        <Dropdown
          Containerwidth={'100%'}
          options={viaDeContactoOptions}
          selectedOption={viaDeContacto}
          setSelectedOption={setViaDeContacto}
        />
        <span style={{
          fontFamily: "'Montserrat', sans-serif"
        }}>Estado *</span>
        <Dropdown
          Containerwidth={'100%'}
          options={statusOptions}
          selectedOption={statusContact}
          setSelectedOption={setStatusContact}
        />
        <span>Observaciones *</span>
        <TextArea
          placeholder='Si desea puede dejar una observacion acerca de su última comunicación..'
          onChange={(e) => handleTextAreareaOnChange(e)}
        />

        <ButtonGroup>
          <Button style={{
            backgroundColor: '#780000',
          }} onClick={handleCancelar}>CANCELAR</Button>
          <Button style={{
            backgroundColor: '#003049',
          }} onClick={handleGuardar}>GUARDAR</Button>
        </ButtonGroup>
      </ModalContent>
    </ModalWrapper>
  );
}

// Componente de selección de hora y minutos
const TimePicker = ({ value, onChange }) => {
  return (
    <TimeInput
      type="time"
      value={value}
      onChange={onChange}

    />
  );
};

const CloseIconImg = styled.img`
  max-width:24px;
  max-height:28px;
  width:24px;
  height:28px;
  cursor:pointer;
  user-select: none;
  &:hover {
    transform: scale(1.1)
  }
`;
const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
  padding: 30px;
  width: -webkit-fill-available;
  max-width:400px;
  padding: 20px auto;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  max-height:80vh;
  overflow-y: auto;
  display:flex;
  flex-direction: column;
  align-items: flex-start;
  gap:16px;
  &::-webkit-scrollbar {
    height: 4px;
    width: 3px;
    background-color: transparent !important;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: #003049 !important;
    border-radius: 8px;
  }
`;

const Button = styled.button`
  padding: 10px 20px;
  margin-top: 10px;
  border: none;
  border-radius: 5px;
  background-color: #007bff;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-weight:500;
  font-family: 'Montserrat', sans-serif;
  &:hover {
    background-color: #0056b3;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  // border:solid 1px red;
  width:-webkit-fill-available;
  justify-content: space-between;
  align-items: center;
`;

const TimeInput = styled.input`
  margin-top: 10px;
  padding: 10px 20px;
  border-radius: 5px;
  border: 1px solid #ccc;
  width: -webkit-fill-available;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  min-height:20px;
  
  @media screen and (max-width: 768px) {
    font-size: 12px;
  }
`;


const TextArea = styled.textarea`
  margin-top: 10px;
  padding: 10px 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  width: -webkit-fill-available !important;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 12px;
  min-height:80px;
  resize: none;
  &:placeholder{
    font-family: 'Montserrat', sans-serif;
  }
  @media screen and (max-width: 768px) {
    font-size: 12px;
  }
`;